module.exports = __webpack_public_path__ + "static/media/gold.aa6af3f4.svg";